export default __webpack_public_path__ + "static/media/ic-agency-summary.5c457b64.svg";